import { useMemo } from 'react';

import { captureError, captureEvent, capturePersonProperties } from './client';

/**
 * Analytics facade — feature code records product/web events through this, never
 * the vendor directly.
 */
export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  captureEvent(name, properties);
}

/**
 * Records a handled or unhandled error for error tracking. Attach only a
 * `surface`/`flow` style context — never user data or request payloads.
 */
export function trackException(error: unknown, properties?: Record<string, unknown>): void {
  captureError(error, properties);
}

/**
 * Sets analytics person properties (demographics). Values must be PII-free:
 * counts, booleans, and enum-ish strings only — never balances, names, or ids
 * other than the pseudonymous distinct id.
 */
export function setPersonProperties(properties: Record<string, unknown>): void {
  capturePersonProperties(properties);
}

export type Analytics = {
  trackEvent: typeof trackEvent;
};

export function useAnalytics(): Analytics {
  return useMemo<Analytics>(() => ({ trackEvent }), []);
}
